/* Nightwarden OPS skin: two-tone headlines on the dark product page.
   "THE FULL SPEC SHEET. NOTHING HIDDEN." → first sentence white, the rest in the accent colour.
   Plain-text headings only; headings containing markup are left alone. */
(function(){
  function run(){
    var els=document.querySelectorAll('.nw-dark .rh-sec .rh-h2, .nw-dark .nwb__h, .nw-2t');
    for(var i=0;i<els.length;i++){
      var h=els[i];
      if(h.getAttribute('data-nw2')||h.children.length)continue;
      var t=h.textContent.replace(/\s+/g,' ').trim();
      var m=t.match(/^(.+?[.?!:])\s+(\S.+)$/);
      if(!m)continue;
      h.setAttribute('data-nw2','1');
      h.textContent='';
      var a=document.createElement('span');a.className='nw-l1';a.textContent=m[1];
      var b=document.createElement('span');b.className='nw-acc';b.textContent=m[2];
      h.appendChild(a);h.appendChild(document.createTextNode(' '));h.appendChild(b);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
})();

/* Menu shortcuts: #faq, #reviews, #guarantee, #specs, #kits jump to those sections wherever they sit on the page. */
(function(){
  var MAP={how:'[id^="rhmc-"]',faq:'[id^="rhfq-"]',reviews:'[id^="rhsp-"], [id^="rhrv-"], [class^="qrs-"]',guarantee:'[id^="rhgr-"]',specs:'#specs',kits:'#kits'};
  function go(h,smooth){
    var k=(h||'').replace('#','').toLowerCase(); if(!MAP[k])return false;
    var el=document.querySelector(MAP[k]); if(!el)return false;
    var y=el.getBoundingClientRect().top+window.pageYOffset-70;
    window.scrollTo({top:y,behavior:smooth?'smooth':'auto'}); return true;
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[href*="#"]'); if(!a)return;
    var u; try{u=new URL(a.href,location.href);}catch(x){return;}
    if(u.pathname===location.pathname&&u.hash&&go(u.hash,true)){e.preventDefault();var d=a.closest('details[open]');if(d)d.removeAttribute('open');}
  });
  function onLoad(){if(location.hash)setTimeout(function(){go(location.hash,false);},400);}
  if(document.readyState==='complete')onLoad();else window.addEventListener('load',onLoad);
})();
